var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.showPop && 'show-pop',attrs:{"id":"app"}},[_c('img',{attrs:{"src":_vm.defaultUlr},on:{"click":_vm.auth}}),(_vm.showWaiting)?_c('waiting',{staticClass:"wait"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }